var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var extendColor = function (color, matches) {
    var result = __spread(color);
    matches.forEach(function (v) {
        if (v !== undefined) {
            result.push(Number(v));
        }
        else {
            result.push(1);
        }
    });
    return result;
};
var ɵ0 = extendColor;
var colorsFromCSS = function (css) {
    var rgb255 = /rgba?\((\d{1,3})\,\s*(\d{1,3})\,\s*(\d{1,3})\,?\s*(\d+\.\d{0,5})?\)/g;
    var colors = [];
    var colorString1 = rgb255.exec(css);
    var colorString2 = rgb255.exec(css);
    colors = extendColor(colors, colorString1.slice(1, 5));
    colors = extendColor(colors, colorString2.slice(1, 5));
    return colors;
};
var ɵ1 = colorsFromCSS;
var BackgroundModel = /** @class */ (function () {
    function BackgroundModel(colors, // 0-255
    gradientType, colorStops) {
        this.colors = colors;
        this.gradientType = gradientType;
        this.colorStops = colorStops;
    }
    BackgroundModel.equals = function (a, b) {
        return a.gradientType === b.gradientType // match gradient
            && a.colors.length === b.colors.length && a.colors.every(function (color, index) { return color === b.colors[index]; }) // match colors
            && a.colorStops.length === b.colorStops.length && a.colorStops.every(function (colorStop, index) { return colorStop === b.colorStops[index]; }); // match color stops      
    };
    // convert degenerate legacy background specs into canonical background model
    BackgroundModel.deserialize = function (chapterBackground) {
        if (!Object.keys(chapterBackground).length) {
            return null;
        }
        // convert colors to rgba e.g. [255,255,255,1]
        var colors = [];
        if (typeof chapterBackground.colors === 'string') {
            colors = colorsFromCSS(chapterBackground.colors);
        }
        else if (Array.isArray(chapterBackground.colors) && chapterBackground.colors.length === 8) {
            // ensure rgb and not 0-1
            colors = chapterBackground.colors.map(function (channel, idx) { return ((idx + 1) % 4 && channel <= 1.0) ? Math.round(channel * 255) : channel; });
        }
        // default to radial if not a valid gradient type
        var gradientType = /radial|linear/.test(chapterBackground.gradientType) ? chapterBackground.gradientType : 'radial';
        // color stops should always be array of numbers between 0 and 100
        var chapterColorStops = chapterBackground.colorStops;
        var colorStops = Array.isArray(chapterColorStops) && chapterColorStops.length === 2
            ? [chapterColorStops[0], chapterColorStops[1]]
            : [0, 100];
        return new BackgroundModel(colors, gradientType, colorStops);
    };
    // css gradient style with 2 and only 2 color stops
    BackgroundModel.toCSS = function (background) {
        var c = background.colors;
        var colorstop1 = "rgba(" + c[0] + "," + c[1] + ", " + c[2] + ", " + c[3] + ") " + background.colorStops[0] + "%";
        var colorstop2 = "rgba(" + c[4] + "," + c[5] + ", " + c[6] + ", " + c[7] + ") " + background.colorStops[1] + "%";
        if (background.gradientType === 'radial') {
            return "radial-gradient(circle, " + colorstop1 + ", " + colorstop2 + ")";
        }
        else {
            return "linear-gradient(180deg, " + colorstop1 + ", " + colorstop2 + ")";
        }
    };
    // from css gradient to Background Model
    BackgroundModel.fromCSS = function (css) {
        // gradient type
        var gradientType = /radial-gradient/.test(css) ? 'radial' : 'linear';
        // colors
        var colors = colorsFromCSS(css);
        // color stops
        var stopRX = /([0-9]+)\%/g;
        var colorStops = [0, 100];
        colorStops[0] = Number(stopRX.exec(css)[1]);
        colorStops[1] = Number(stopRX.exec(css)[1]);
        return new BackgroundModel(colors, gradientType, colorStops);
    };
    BackgroundModel.isTransparent = function (background) {
        // If not chapter is set, infer default background
        if (!background || !background.colors) {
            return false;
        }
        var colors = background.colors;
        var alpha1 = colors[3];
        var alpha2 = colors[7];
        // 4 vs 8 colors
        return colors.length <= 4 ? alpha1 === 0 : (alpha1 === 0 && alpha2 === 0);
    };
    return BackgroundModel;
}());
export { BackgroundModel };
export { ɵ0, ɵ1 };
